import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetailPage from "../pages/article-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-acbuyspreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;